(function(){
  // Finds the color option input (radio or select) within a given product form/variant picker
  function findColorControl(root) {
    // Dawn radios
    let radioFieldset = root.querySelector('fieldset[data-option-name], fieldset.js.product-form__input');
    let candidates = Array.from(root.querySelectorAll('fieldset[data-option-name]')).concat(
      Array.from(root.querySelectorAll('fieldset.js.product-form__input'))
    );
    // Prefer the one whose label/name includes "color"
    let colorFieldset = candidates.find(fs => {
      let name = (fs.getAttribute('data-option-name') || '').toLowerCase();
      if (name.includes('color')) return true;
      // fallback: look for legend text
      const legend = fs.querySelector('legend');
      return legend && legend.textContent.toLowerCase().includes('color');
    });

    if (colorFieldset) return { type: 'radios', el: colorFieldset };

    // Dawn selects (variant-selects)
    const selects = Array.from(root.querySelectorAll('select[name^="options["]'));
    const colorSelect = selects.find(s => s.name.toLowerCase().includes('color'));
    if (colorSelect) return { type: 'select', el: colorSelect };

    return null;
  }

  function setControlValue(control, value) {
    if (!control) return;
    if (control.type === 'radios') {
      const input = Array.from(control.el.querySelectorAll('input[type="radio"]'))
        .find(i => (i.value || '').toLowerCase() === value.toLowerCase());
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (control.type === 'select') {
      control.el.value = value;
      control.el.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function updateActiveClass(groupRoot, value) {
    const btns = groupRoot.querySelectorAll('.bal-color-swatch');
    btns.forEach(b => b.classList.toggle('is-active', (b.dataset.optionValue || '').toLowerCase() === value.toLowerCase()));
  }

  // Delegate clicks for any swatch on the page (works with multiple products)
  document.addEventListener('click', function(e){
    const btn = e.target.closest('.bal-color-swatch');
    if (!btn) return;

    // Find the closest product context (Dawn product form / variant picker)
    const productRoot =
      btn.closest('product-form') ||
      btn.closest('variant-picker') ||
      btn.closest('section[id^="balenciaga-pdp"]') ||
      document;

    const pickerRoot = productRoot.querySelector('variant-picker, .product__info-container, form[action*="/cart/add"]') || productRoot;

    const colorValue = btn.dataset.optionValue;
    const variantId = btn.dataset.variantId;

    // 1) Set the Color option in Dawn (radio or select)
    const control = findColorControl(pickerRoot);
    setControlValue(control, colorValue);

    // 2) Toggle active class
    updateActiveClass(productRoot, colorValue);

    // 3) After Dawn recomputes the selected variant, update the URL (?variant=)
    //    We wait a microtask to let the hidden id input update.
    setTimeout(() => {
      const idInput = productRoot.querySelector('input[name="id"]');
      const id = (idInput && idInput.value) || variantId;
      if (id) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      }
    }, 0);
  });
})();
